const ROUTES_KEY = 'openroute:saved_routes';
const SETTINGS_KEY = 'openroute:settings';

export function loadRoutes() {
  try {
    const raw = localStorage.getItem(ROUTES_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function saveRoutes(routes) {
  try {
    localStorage.setItem(ROUTES_KEY, JSON.stringify(routes));
  } catch (e) {
    console.error('Failed to save routes to localStorage:', e);
  }
}

export function loadSettings() {
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function saveSettings(settings) {
  try {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
  } catch (e) {
    console.error('Failed to save settings:', e);
  }
}
